import Model from "@/lib/model/model";
import { CandidateResult } from "@/lib/model/exam/result";
// 候选人能力评价
enum evaluation {
  // "欠佳" = "候选人在普通话测评中发音失误多，表达时难以听清表达内容。候选人有可能存在方言口音或面试时处在环境嘈杂的地方进行面试等情况，该水平可能难以胜任普通话口语表达密切相关岗位。",
  // "中等" = "候选人在普通话测评中发音基本标准，但存在调值或难点音(平翘舌音、前后鼻尾音等)不准情况，该水平能胜任一般的依赖普通话沟通的岗位。",
  // "优秀" = "候选人在普通话测评中的发音准确，吐字清晰，表达流畅，该水平能够在大部分使用普通话沟通的场景中顺利地完成交谈，可胜任大部分需要普通话表达能力的职业。"
  "未作答" = "候选人未作答或回答过于简短，无法考察普通话能力水平",
  "欠佳" = "候选人在回答时发音失误多，表达时难以听清表达内容。候选人有可能存在方言口音或面试时处在环境嘈杂的地方进行面试等情况。",
  "中等" = "候选人在回答时发音基本标准，但存在调值或难点音(平翘舌音、前后鼻尾音等)不准情况。",
  "优秀" = "候选人在回答时的发音准确，吐字清晰，表达流畅。"
}
export default class ChineseAssessmentResult extends Model {
  soeScore = 0; // 原始分数
  prScore = 0; // 百分位

  // 判断评价
  getEval(all: CandidateResult) {
    const mark = this.prScore;

    const {
      iseChineseScorePercentLimit1: limit1,
      iseChineseScorePercentLimit2: limit2
    } = all.reportShowConfig;

    if (mark === 0) {
      return { tag: "未作答", color: "", level: "0" };
    }

    if (mark > 0 && mark < limit1) {
      return { tag: "欠佳", color: "#EF483F", level: "3" };
    }

    if (mark >= limit1 && mark < limit2) {
      return { tag: "中等", color: "#FFC803", level: "2" };
    }

    if (mark >= limit2 && mark <= 100) {
      return { tag: "优秀", color: "#00BD82", level: "1" };
    }

    return { tag: "优秀", color: "#00BD82", level: "1" };
  }

  mandarinContent(isH5: boolean, all: CandidateResult): string {
    const { color, tag } = this.getEval(all);

    if (tag === "未作答") {
      return evaluation[tag];
    }

    const hidePercent =
      all.reportShowConfig?.hiddenIseChineseScorePercent === 1;
    const tagHtml = `<span class="h5-markednessText" style="color: ${color};">${tag}</span>`;

    if (isH5) {
      const scorePercent: string = hidePercent
        ? ""
        : `候选人在常模中处于<span class="markednessText">${this.prScore}%</span>分位，`;
      return `${scorePercent}展现出了${tagHtml}的普通话水平。${evaluation[tag]}`;
    }

    const scorePercent: string = hidePercent
      ? ""
      : `在常模人群中处于<span class="markednessText">${this.prScore}%</span>分位。`;
    return `候选人的普通话水平${tagHtml}，${scorePercent}${evaluation[tag]}`;
  }
}
